// import React, { Fragment, useState } from "react";
// import { BrowserRouter, Route, Switch } from "react-router-dom";
// import { connect, useSelector } from "react-redux";
// import axios from "axios";
// import LoadingOverlay from "../components/UI/LoadingOverlay/LoadingOverlay";
// import AuthContext from "../context/auth-context";
// import Login from "./Auth/Login/Login";
// import TopMenu from "../components/Navigation/TopMenu/TopMenu";
// import LeftMenu from "../components/Navigation/LeftMenu/LeftMenu";
// import Content from "../components/Content/Content";
// import Footer from "../components/Footer/Footer";
// import ForgotPassword from "./Auth/ForgotPassword/ForgotPassword";
// import ExpiredPassword from "./Auth/ExpiredPassword/ExpiredPassword";
// import PristineAccount from "./Auth/PristineAccount/PristineAccount";
// import ErrorPage404 from "../components/Content/NotFoundErrorPage/NotFoundErrorPage";
// import "./App.css";
// import Mainteinance from "./Mainteinance";

// const App = (props) => {
//   const [inMaintenance] = useState(false);
//   axios.defaults.headers = {
//     Authorization: props.authData.accessToken,
//     "Company-Code": props.authData.companyCode,
//     "Company-Id": props.authData.companyId,
//     "Login-Audit-Id": props.authData.loginLogId,
//     "User-Id": props.authData.userId,
//     "Cache-Control": "no-store",
//     Pragma: "no-cache",
//   };

//   const companies = useSelector((state) => state.utilities.companies.data);
//   let companyName = "Loading...";
//   if (Array.isArray(companies) && companies.length > 0) {
//     const company = companies.find(
//       (company) => company.id === props.authData.companyId
//     );
//     if (company) {
//       companyName = company.name;
//     }
//   }

//   window.addEventListener("beforeunload", (event) => {
//     event.returnValue = `Are you sure you want to leave?`;
//   });
//   return (
//     <>
//       <BrowserRouter>
//         <Switch>
//           <Route
//             path="/"
//             exact
//             component={inMaintenance ? Mainteinance : Login}
//           />
//           <Route path="/forgot-password" exact component={ForgotPassword} />
//           <Route path="/expired-password" exact component={ExpiredPassword} />
//           <Route
//             path="/pristine-account/:code/:company_id/:username/:initial_password"
//             exact
//             component={PristineAccount}
//           />
//           <AuthContext.Provider
//             value={{
//               authenticated: props.authData.authenticated,
//               isAdmin: props.authData.isAdmin,
//               companyCode: props.authData.companyCode,
//               companyId: props.authData.companyId,
//               companyName: companyName,
//               userId: props.authData.userId,
//               userName: props.authData.userName,
//               isICT: props.authData.isICT,
//               userEmail: props.authData.userEmail,
//               accessToken: props.authData.accessToken,
//               refreshToken: props.authData.refreshToken,
//               loginLogId: props.authData.loginLogId,
//               tokenIsValid: props.authData.tokenIsValid,
//               loginName: props.authData.loginName,
//             }}
//           >
//             <TopMenu />
//             <LeftMenu />
//             <Content />
//             <Footer />
//           </AuthContext.Provider>
//           <Route component={ErrorPage404} />
//         </Switch>
//       </BrowserRouter>
//       <LoadingOverlay isActive={props.loading}></LoadingOverlay>
//     </>
//   );
// };

// const mapStateToProps = (state) => {
//   return {
//     authData: state.auth.authData,
//     loading: state.utilities.loading,
//   };
// };

// export default connect(mapStateToProps)(App);

import React, { Fragment, useState, useEffect } from "react"; // ✅ Added useEffect
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import axios from "axios";
import LoadingOverlay from "../components/UI/LoadingOverlay/LoadingOverlay";
import AuthContext from "../context/auth-context";
import Login from "./Auth/Login/Login";
import TopMenu from "../components/Navigation/TopMenu/TopMenu";
import LeftMenu from "../components/Navigation/LeftMenu/LeftMenu";
import Content from "../components/Content/Content";
import Footer from "../components/Footer/Footer";
import ForgotPassword from "./Auth/ForgotPassword/ForgotPassword";
import ExpiredPassword from "./Auth/ExpiredPassword/ExpiredPassword";
import PristineAccount from "./Auth/PristineAccount/PristineAccount";
import ErrorPage404 from "../components/Content/NotFoundErrorPage/NotFoundErrorPage";
import "./App.css";
import Mainteinance from "./Mainteinance";

const App = (props) => {
  const [inMaintenance] = useState(false);

  // ✅ FIX: Use useEffect to update axios headers only when authData changes
  useEffect(() => {
    // Only set headers if user is authenticated and has a token
    if (props.authData.authenticated && props.authData.accessToken) {
      axios.defaults.headers = {
        Authorization: props.authData.accessToken,
        "Company-Code": props.authData.companyCode || '',
        "Company-Id": props.authData.companyId || '',
        "Login-Audit-Id": props.authData.loginLogId || '',
        "User-Id": props.authData.userId || '',
        "Cache-Control": "no-store",
        Pragma: "no-cache",
      };
    }
    // Optional: If not authenticated, clear sensitive headers
    else {
      // Keep Cache-Control and Pragma, remove auth headers
      axios.defaults.headers = {
        "Cache-Control": "no-store",
        Pragma: "no-cache",
      };
    }
  }, [props.authData]); // ✅ Runs when authData changes (login, logout, or rehydrate)

  const companies = useSelector((state) => state.utilities.companies.data);
  let companyName = "Loading...";
  if (Array.isArray(companies) && companies.length > 0) {
    const company = companies.find(
      (company) => company.id === props.authData.companyId
    );
    if (company) {
      companyName = company.name;
    }
  }

  //  Add cleanup for beforeunload event
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.returnValue = `Are you sure you want to leave?`;
    };
    
    window.addEventListener("beforeunload", handleBeforeUnload);
    
    // Cleanup event listener when component unmounts
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <BrowserRouter>
        <Switch>
          <Route
            path="/"
            exact
            component={inMaintenance ? Mainteinance : Login}
          />
          <Route path="/forgot-password" exact component={ForgotPassword} />
          <Route path="/expired-password" exact component={ExpiredPassword} />
          <Route
            path="/pristine-account/:code/:company_id/:username/:initial_password"
            exact
            component={PristineAccount}
          />
          <AuthContext.Provider
            value={{
              authenticated: props.authData.authenticated,
              isAdmin: props.authData.isAdmin,
              companyCode: props.authData.companyCode,
              companyId: props.authData.companyId,
              companyName: companyName,
              userId: props.authData.userId,
              userName: props.authData.userName,
              isICT: props.authData.isICT,
              userEmail: props.authData.userEmail,
              accessToken: props.authData.accessToken,
              refreshToken: props.authData.refreshToken,
              loginLogId: props.authData.loginLogId,
              tokenIsValid: props.authData.tokenIsValid,
              loginName: props.authData.loginName,
            }}
          >
            <TopMenu />
            <LeftMenu />
            <Content />
            <Footer />
          </AuthContext.Provider>
          <Route component={ErrorPage404} />
        </Switch>
      </BrowserRouter>
      <LoadingOverlay isActive={props.loading}></LoadingOverlay>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    authData: state.auth.authData,
    loading: state.utilities.loading,
  };
};

export default connect(mapStateToProps)(App);
